import { Index } from 'solid-js'

import { DurationDisplay, Field, Select, Text, createListCollection } from '@components'
import { type Duration, durationList } from '@here/api'
import { ChevronDownIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { LastSelectDisabled } from './LastSelectDisabled'

export default function () {
	const { filters, setDuration } = useService(useFilters)()

	const collection = createListCollection({ items: durationList })

	const selected = () => filters().duration

	return (
		<Field.Root>
			<Field.Label>Pattern Candlestick Time Frame</Field.Label>
			<Select.Root
				positioning={{
					sameWidth: true,
				}}
				multiple
				value={selected()}
				collection={collection}
				onValueChange={({ value }) => setDuration(value as Duration[])}
			>
				<Select.Control>
					<Select.Trigger>
						<Select.ValueText
							asChild={(props) => (
								<Text>
									{props()
										.children?.toString()
										.replace('intraday', '< Daily')
										.replace('multiday', '> Daily')}
								</Text>
							)}
						/>
						<Select.Indicator>
							<ChevronDownIcon />
						</Select.Indicator>
					</Select.Trigger>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						<Select.ItemGroup>
							<Index each={collection.items}>
								{(item) => (
									<LastSelectDisabled
										innerTemplate={(value) => (
											<DurationDisplay duration={value as Duration} />
										)}
										item={item()}
										selected={selected()}
									/>
								)}
							</Index>
						</Select.ItemGroup>
					</Select.Content>
				</Select.Positioner>
				<Select.HiddenSelect />
			</Select.Root>
		</Field.Root>
	)
}
